export default "__VITE_ASSET__CAC_GJTN__"